/* istanbul ignore file */
function FirebaseAnalytics() {
  if (typeof window === 'undefined') return null;

  const firebaseConfig = {
    apiKey: process.env.FIREBASE_API_KEY,
    authDomain: process.env.FIREBASE_AUTH_DOMAIN,
    projectId: process.env.FIREBASE_PROJECT_ID,
    storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.FIREBASE_APP_ID,
    measurementId: process.env.FIREBASE_MEASUREMENT_ID,
  };

  if (!firebaseConfig.apiKey || !firebaseConfig.measurementId) return null;

  try {
    // eslint-disable-next-line
    const { initializeApp, getApps, getApp } = require('firebase/app');
    // eslint-disable-next-line
    const { initializeAnalytics, getAnalytics } = require('firebase/analytics');
    const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

    if (process.env.FIREBASE_DEBUG_MODE === 'true') {
      try {
        return initializeAnalytics(app, { config: { debug_mode: true } });
      } catch (e) {
        // show when debug mode only
        console.error(e);
      }
    }
    return getAnalytics(app);
  } catch (e) {
    return null;
  }
}

export default new FirebaseAnalytics();
